import { auth } from "./firebase";

export const verifyLogin = () =>
  new Promise((resolve) => {
    auth.onAuthStateChanged((user) => {
      if (!user) resolve(false);
      else
        user
          .getIdToken()
          .then((t) => resolve(t))
          .catch(() => resolve(false));
    });
  });
